<template>
	<div class="text-list"  v-loading.fullscreen.lock="loading"
		element-loading-text="拼命加载中">
		<div class="text-list-nav">
			<h3>资源导航</h3>
			<div class="text-list-nav-box">
				<ul>
					<li class="text-list-nav-path" v-for="(item, index) of subjectList" :key="index">
						<span>{{item.subject_name}}</span>
						<router-link :to="{path: '/test/item-bank',query: {subject: item.subject_id}}">试题</router-link>
						<router-link :to="{path: '/test/common-library',query: {subject: item.subject_id}}">试卷</router-link>
					</li>
				</ul>
			</div>	
		</div>
 <!--  -->
		<div class="text-list-cont">
			<div class="text-list-cont-title">
				<span>试卷</span>
				<a @click="routeMore">更多 ></a>
			</div>

			<ul>
				<template v-for="(item, index) of testList">
					<li class="text-list-li text-library" v-if="index < 8"  :key="index">
						<span></span>
						<div class="text-list-li-info">
							<p>{{item.name}}</p>
							<p>更新于：{{item.update_time.substring(0, 16)}}</p>
							<div class="text-list-li-op">
								<ul>
									<li v-if="item.grade">{{item.grade}}</li>
									<li v-if="item.subjec">{{item.subject}}</li>
									<li v-if="item.version_name">{{item.version_name}}</li>
									<li v-if="item.source">{{item.source}}</li>
								</ul>
								<router-link :to="{path: '/test/details', query: {id: item.id}}">预览</router-link>
							</div>
						</div>
					</li>
				</template>
			</ul>

			<div class="dependent" v-if="placeholder">
				<i class="ipng image_state01"></i>
				<p>还没发现任何相关的内容哦~</p>
			</div>
		</div>
	</div>
</template>

<script>
	
	export default {
		data(){
			return {
				testList: [], /*试卷列表*/
				subjectList: [],
				loading: true,
				placeholder: false,
				subject: sessionStorage.getItem('subjectID')
			}
		},
		watch: {
			'$store.state.questionChange': {
				handler(val, newval){
					this.subject = sessionStorage.getItem('subjectID')
					this.getTestList()
				},
				immediate: true
			}
		},
		created(){
			// this.getTestList()
			this.subjectData()
		},
		mounted(){
			
		},
		methods: {
			routeMore(){
				let id = sessionStorage.getItem('subjectID');
				this.$router.push({path: '/test/common-library',query: {subject: id}})
			},
			subjectData(){
				let success = (res=>{
					// this.subjectList = res.data;
					let subjectArr = []
					for (let i = 0; i <  res.data.length; i++) {

						if (!subjectArr.includes(res.data[i].subject_id)) {

							this.subjectList.push(res.data[i])
						}

						subjectArr.push( res.data[i].subject_id)
					}

				});

				let params = {
					grade_id: 0,
					subject_id:0,
					version_id:0,
					page_index:0,
					page_size:0
				};

				this.$ajax({
					url: 'api/cate/subject_data',
					method: 'get',
					params: params,
					func: {success: success}
				})
			},
			/**
			 * 请求试卷列表
			 * @DateTime 2019-07-22T13:47:02+0800
			 */
			getTestList(){
				let success = ( res=>{

					// console.log((this.subject == 0 ?  this.subject : sessionStorage.getItem('subjectID')), this.subject, sessionStorage.getItem('subjectID'), 99)
					this.testList = res.data.data;
					this.loading = false;
					this.testList.length != 0 ? this.placeholder = false : this.placeholder = true;
				});

				let params = {
					// user_id: this.$g.user_id,
					page_index: 1,
					page_size: 0,
					status: 1,
					authority: 1,
					subject_id: this.subject
				};

				this.$ajax({
					url: 'api/newtest/test_list',
					method: 'get',
					params: params,
					func: {success: success}
				})
			}
		}
	}
</script>